import { Refine } from "@refinedev/core";
import { RefineSnackbarProvider } from "@refinedev/mui";
import CssBaseline from "@mui/material/CssBaseline";
import GlobalStyles from "@mui/material/GlobalStyles";
import routerBindings from "@refinedev/react-router";
import { ColorModeContextProvider } from "./contexts/color-mode";
import AppRoutes from "./route/AppRoutes";
import { AppViewModel } from "./viewmodel/AppViewModel";
import { useSelector, Provider } from "react-redux";
import { Suspense, lazy } from "react";
import { RootState } from "./store/types";
import { store } from "./store";
import { BrowserRouter } from "react-router";
import { COLORS } from "./constant/color";
import AppV2 from "./AppV2";
import { ROUTES } from "./route/RouteConstant";

// Defer non-critical CSS
if (typeof window !== 'undefined') {
  import("./styles/modal-loader-overlay.css");
}
import CircularScreenLoader from "./components/CircularScreenLoader";
import { selectSidebarPermissionStatus } from "./store/selectors/sidebarMenuSelectors";
import { Box, CircularProgress } from "@mui/material";

// Lazy load heavy toast container
const ToastContainer = lazy(() => import("react-toastify").then(m => ({ default: m.ToastContainer })));
const HandlePermissionLoadingScreen = lazy(() => import("./components/HandlePermissionLoadingScreen"));

function App() {
  const { allowed, appReady, userData, userDetailsLoading, userDetailsError } = AppViewModel();
  const sidebarPermissionStatus = useSelector(selectSidebarPermissionStatus);
  const userReady =
    allowed && appReady && userData && Object.keys(userData).length;

  const path = window.location.pathname;

  // this code is commented to allow loading of route without initData or cookies as we have a separate auth mechanism previously it depended on initData or cookies from .net neuron app
  if (!userReady && path != ROUTES.CUSTOMER_360 && path != "/neuron/chatbot") {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100vh"
        bgcolor={COLORS.dark.backgroundDefault}
      >
        <CircularProgress />
      </Box>
    );
  }
  return ( 
      <BrowserRouter>
        <Suspense fallback={null}>
          <ToastContainer position="top-right" autoClose={3000} />
        </Suspense>
        <ColorModeContextProvider>
          <RefineSnackbarProvider>
            <Refine 
              routerProvider={routerBindings}
              options={{ disableTelemetry: true }}
            >
              <CssBaseline />
              <GlobalStyles styles={{ html: { WebkitFontSmoothing: "auto" } }} />
              <Suspense fallback={<CircularScreenLoader loading={true} />}>
              {/* Modal loader overlay for userDetailsLoading or sidebar permission status */}
              {(sidebarPermissionStatus) && (
                <div className="modal-loader-overlay">
                  <Suspense fallback={<></>}>
                    <HandlePermissionLoadingScreen message={userDetailsLoading ? userDetailsError : sidebarPermissionStatus} />
                  </Suspense>
                </div>
              )}
              {path === ROUTES.CUSTOMER_360 || path === "/neuron/chatbot" ? (
                <AppV2 />
              ) : (
                <AppRoutes />
              )}

              </Suspense>
            </Refine>
          </RefineSnackbarProvider>
        </ColorModeContextProvider>
      </BrowserRouter>
  );
}

export default App;
